import React from 'react';

import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import UserInfoContacts from './components/UserInfoContacts';
import UserInfoDates from './components/UserInfoDates';
import { AvailableStyled, AvailableWrapperStyled } from './styles';
import UserAvatar from '../../../../components/UserAvatar';
import { AVAILABLES } from '../../../../constants/availables';
import { IUser } from '../../../../types/user.type';
import { SectionWrapper } from '../../styles';

interface IProps {
  user: IUser;
}

const UserInfo = React.memo(({ user }: IProps) => {
  const { t } = useTranslation();

  const isAvailable = React.useMemo(() => user?.available === 1, [user]);

  const available = React.useMemo(() => {
    if (!user) {
      return null;
    }

    const label = AVAILABLES.find((item) => item.value === user.available);

    if (!label) {
      return null;
    }

    return t(`general.${label.label}`);
  }, [t, user]);

  return (
    <SectionWrapper spacing={2.5} sx={{ paddingTop: 5.5 }} data-testid="user-info">
      <Stack justifyContent="center" alignItems="center" spacing={2.5}>
        <UserAvatar user={user!} size={144} />

        <Typography variant="h3" sx={{ textWrap: 'wrap', textAlign: 'center' }}>
          {user.firstname} {user.lastname}
        </Typography>
      </Stack>

      <Stack>
        <AvailableWrapperStyled isAvailable={isAvailable}>
          <AvailableStyled variant="md" isAvailable={isAvailable}>
            {available}
          </AvailableStyled>
        </AvailableWrapperStyled>
      </Stack>

      <UserInfoContacts user={user} />
      <UserInfoDates user={user} />
    </SectionWrapper>
  );
});

export default UserInfo;
